import { i18next } from '@yola/ws-sdk';
import ai from 'src/js/modules/ai';

const {
  constants: { textAssistantInstructionTones },
} = ai;

const getTextAssistantToneOptions = () => [
  {
    value: textAssistantInstructionTones.PROFESSIONAL,
    label: i18next.t('Professional'),
  },
  {
    value: textAssistantInstructionTones.CASUAL,
    label: i18next.t('Casual'),
  },
  {
    value: textAssistantInstructionTones.STRAIGHTFORWARD,
    label: i18next.t('Straightforward'),
  },
  {
    value: textAssistantInstructionTones.CONFIDENT,
    label: i18next.t('Confident'),
  },
  {
    value: textAssistantInstructionTones.FRIENDLY,
    label: i18next.t('Friendly'),
  },
];

export default getTextAssistantToneOptions;
